/**
 * Shared helpers for activity pax (participant) handling, used by the guest
 * booking engine and the staff activity/billing modals.
 *
 * Pricing rule: an activity is billed for at least its `minimum_pax`. Steppers
 * enforce this by selecting "0, or a value in [minPax..maxPax]" — so a selected
 * activity always bills for the minimum even when fewer guests join.
 */

// Human-readable pax constraint, e.g. "2–6 guests" / "Minimum 2 guests".
export const paxLabel = (minPax, maxPax) => {
  if (minPax > 1 && maxPax > 0) return `${minPax}–${maxPax} guests`;
  if (minPax > 1) return `Minimum ${minPax} guests`;
  if (maxPax > 0) return `Up to ${maxPax} guests`;
  return "Any group size";
};

// Split inclusions/exclusions text into trimmed, non-empty lines.
export const toActivityLines = (text) =>
  (text || "").split("\n").map((s) => s.trim()).filter(Boolean);

// Next count for an activity stepper. The first increment jumps 0 -> minPax,
// decrementing at minPax clears to 0, and the count never exceeds maxPax.
// Returns the count unchanged when a bound is hit.
export const stepPaxCount = (current, minPax, maxPax, increment) => {
  const min = minPax || 1;
  const max = maxPax || 0;
  if (increment) {
    const next =
      current === 0 && min > 1 ? (max > 0 ? Math.min(min, max) : min) : current + 1;
    return max > 0 && next > max ? current : next;
  }
  if (current <= 0) return 0;
  return min > 1 && current <= min ? 0 : current - 1;
};
